/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVersionResponseDto } from '../../models/backend-version-response-dto';

export interface VersionVersionGet$Params {}

export function versionVersionGet(
  http: HttpClient,
  rootUrl: string,
  params?: VersionVersionGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVersionResponseDto>> {
  const rb = new RequestBuilder(rootUrl, versionVersionGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVersionResponseDto>;
    }),
  );
}

versionVersionGet.PATH = '/version';
